// The Zenarty mark: the black "Z" on the brand red, traced from the brand artwork
// (a 198-unit square). Used in the sidebar and on the sign-in page; the favicon in
// public/favicon.svg draws the same paths.
import { useId } from 'react';

export const BRAND_RED = '#db3623';
const Z_MAIN = 'M1 0H178L198 42L43 198H0V155L97 58H20Z';
const Z_KICK = 'M99 140H179L198 198H120Z';

/** The bare Z (inherits `color`), for use on any background. */
export function ZMark({ size = 24, title }: { size?: number; title?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 198 198"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <path d={Z_MAIN} fill="currentColor" />
      <path d={Z_KICK} fill="currentColor" />
    </svg>
  );
}

/** The app icon: black Z on a red tile with the brand's soft white glow. */
export function LogoTile({ size = 32 }: { size?: number }) {
  const glow = `zenarty-glow-${useId().replace(/:/g, '')}`;
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label="Zenarty">
      <defs>
        <radialGradient id={glow} cx="0.92" cy="0.12" r="0.75">
          <stop offset="0" stopColor="#fff" stopOpacity="0.85" />
          <stop offset="0.45" stopColor="#fff" stopOpacity="0.12" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill={BRAND_RED} />
      <rect width="64" height="64" rx="14" fill={`url(#${glow})`} />
      <g transform="translate(14 14) scale(0.1818)" fill="#000">
        <path d={Z_MAIN} />
        <path d={Z_KICK} />
      </g>
    </svg>
  );
}
